import React, {useState} from "react"
import {FormattedMessage} from "@irati/utils/lang"
import styled from "styled-components"
import Button from "@irati/ui/src/Button"
import {stopPropagationAndPrevent} from "@irati-web/wallet/src/utils/stopBubbleEvent"

const StyledSpan = styled.span`
  word-break: break-word;
`

interface Props {
  message: string
  isModerated: boolean
  limitTruncate?: number
}
interface TextTruncationProps {
  limit: number
  text: string
}
const TextTruncationAction = styled(Button)`
  text-decoration: underline;
  &:hover {
    box-shadow: none;
  }
`
const TextTruncation: React.FC<TextTruncationProps> = (props) => {
  const {limit, text} = props
  const [expanded, setExpanded] = useState(false)
  const expand = (ev: MouseEvent) => {
    stopPropagationAndPrevent(ev)
    setExpanded(!expanded)
  }
  if (text.length > limit) {
    const textToShow = expanded ? text : `${text.slice(0, limit)}...`
    const readIntlKey = expanded ? "platform.cta.readLess" : "platform.cta.readMore"
    return (
      <StyledSpan>
        {textToShow}
        <TextTruncationAction small cta onClick={expand} marginLeft={1}>
          <FormattedMessage id={readIntlKey} />
        </TextTruncationAction>
      </StyledSpan>
    )
  }
  return <StyledSpan>{text}</StyledSpan>
}
const ModeratedMessage: React.FC<Props> = (props) => {
  const {message, isModerated, limitTruncate} = props

  if (isModerated) {
    return <FormattedMessage id="recognition.moderation.replacement" />
  }

  if (limitTruncate) {
    return <TextTruncation limit={limitTruncate} text={message} />
  }
  return <StyledSpan>{message}</StyledSpan>
}
export default ModeratedMessage
